export default __webpack_public_path__ + "static/iketchak-videoMiseEnAvant-8426bb448a75680f31338352851e6363.mp4";